import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-267">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 w-full p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_40px_-10px_rgba(0,0,0,0.1)] z-50 md:hidden" data-id="element-268">
          <div className="max-w-md mx-auto flex items-center gap-4" data-id="element-269">
            <div className="hidden sm:block" data-id="element-270">
              <p className="text-xs font-bold text-gray-500 uppercase" data-id="element-271">
                Oferta Especial
              </p>
              <p className="font-bold text-dark" data-id="element-272">$6.39 USD</p>
            </div>
            <CTAButton text="SÍ, QUIERO MI BUNDLE" className="py-3 text-base flex-1" data-id="element-273" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}